import { nsTerminal } from '@/app/i18n/namespaces';

const OPERATION_TYPE = {
    AUTHORIZATION: { name: 'AUTHORIZATION', entity: 'operation_type.authorization', namespace: nsTerminal },
    REMOTE_COLLECTION: { name: 'REMOTE_COLLECTION', entity: 'operation_type.remote_collection', namespace: nsTerminal },
    REMOTE_CONFIGURATION: { name: 'REMOTE_CONFIGURATION', entity: 'operation_type.remote_configuration', namespace: nsTerminal },
    BLACKLISTED_POS_TERMINAL: { name: 'BLACKLISTED_POS_TERMINAL', entity: 'operation_type.blacklisted_pos_terminal', namespace: nsTerminal },
    PENDING_PAYMENT: { name: 'PENDING_PAYMENT', entity: 'operation_type.pending_payment', namespace: nsTerminal },
    GET_PACKAGE: { name: 'GET_PACKAGE', entity: 'operation_type.get_package', namespace: nsTerminal },
    INITIALIZATION_NOTIFICATION: { name: 'INITIALIZATION_NOTIFICATION', entity: 'operation_type.initialization_notification', namespace: nsTerminal },
    TERMINAL_STATE: { name: 'TERMINAL_STATE', entity: 'operation_type.terminal_state', namespace: nsTerminal }
};

export default OPERATION_TYPE;